import { createStore, applyMiddleware, type Action } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { thunk, type ThunkMiddleware } from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import sagas from '../sagas/rootSaga';
import rootReducer from '../reducers/rootReducer';
import { AppState } from './types/Store';

type AppAction = Action<string>;
const typedThunk: ThunkMiddleware<AppState, AppAction> = thunk;

export default function configureStore(initialState: AppState) {
  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(
      applyMiddleware(
        sagaMiddleware,
        typedThunk
      )
    )
  );

  // Run sagas
  sagaMiddleware.run(sagas);

  return store;
}

export type RootStore = ReturnType<typeof configureStore>;
export type AppDispatch = RootStore['dispatch'];